module.exports = __webpack_public_path__ + "img/logobot.7e0f30e9.png";